import { render, staticRenderFns } from "./consignAddress.vue?vue&type=template&id=d3e80f6e&"
import script from "./consignAddress.vue?vue&type=script&lang=js&"
export * from "./consignAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports